import axiosClient from "./axiosClient";

const providerApi = {
    getAll: () =>{
        const url = 'api/provider/getall'
        return axiosClient.get(url)
    },
    getById: (params) =>{
        const url = `api/provider/getById/${params}`
        return axiosClient.get(url,params)
    },

    updateById: (params,data) =>{
        const url = `api/provider/${params}`
        return axiosClient.put(url,data)
    },
    create: (data) =>{
        const url = `api/provider/create`
        return axiosClient.post(url,data)
    },
    delete: (params) =>{
        const url = `api/provider/${params}`
        return axiosClient.delete(url)
    },

}
export default providerApi;